<div class="mat-calendar-header">
  <div class="mat-calendar-controls">
    <span [id]="_periodButtonLabelId" class="cdk-visually-hidden" aria-live="polite">{{ periodButtonDescription }}</span>
    <span class="period-text" (click)="currentPeriodClicked()">{{ periodButtonText }}</span>

    <rp-icon
      [iconName]="iconName.ChevronDown"
      class="mat-calendar-period-button"
      (click)="currentPeriodClicked()"
      [attr.aria-label]="periodButtonLabel"
      [attr.aria-describedby]="_periodButtonLabelId"
      size="s"
    />

    <div class="mat-calendar-spacer"></div>

    <ng-content />

    <rp-icon
      [iconName]="iconName.ChevronLeft"
      class="mat-calendar-previous-button"
      [disabled]="!previousEnabled()"
      (click)="previousClicked()"
      [attr.aria-label]="prevButtonLabel"
      size="s"
    />

    <rp-icon
      [iconName]="iconName.ChevronRight"
      class="mat-calendar-next-button"
      [disabled]="!nextEnabled()"
      (click)="nextClicked()"
      [attr.aria-label]="nextButtonLabel"
      size="s"
    />
  </div>
</div>
